// A gate's own image, falling back to its initials (or number) if it's missing or fails to load.
import React from 'react';

// "Home Plate" -> "HP", "Gate 13" -> "13"
export const gateInitials = (label) => {
  const number = label.match(/(\d+)\s*$/);
  if (number) return number[1].slice(0, 3);
  return label.split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
};

const GateIcon = ({ imageURL, label, className = '' }) => (
  <span className={`gx-gate-icon ${className}`}>
    <span className="gx-gate-initials">{gateInitials(label)}</span>
    {imageURL && (
      <img
        src={imageURL}
        alt=""
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    )}
  </span>
);

export default GateIcon;
